module.exports = new __parcel__URL__("capacity_icon_small.0d1649a9.png").toString();